import { Link } from "react-router-dom";
import { formatINR } from "@/lib/api";
import { Star } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const absUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export default function ProductCard({ brand }) {
    if (!brand) return null;
    const heroImage = brand.hero_image_url;
    return (
        <Link
            to={`/brand/${brand.slug}`}
            data-testid={`brand-card-${brand.slug}`}
            className="rk-card group bg-white border border-rk-border flex flex-col overflow-hidden"
        >
            {/* Top: Hero image (admin-uploaded) — fills the whole square */}
            <div className="aspect-square relative overflow-hidden bg-rk-cream">
                {heroImage ? (
                    <img
                        src={absUrl(heroImage)}
                        alt={brand.brand_name}
                        loading="lazy"
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center p-6 bg-white">
                        <BrandLogo brand={brand} size="lg" />
                    </div>
                )}
                {brand.discount_percentage > 0 && (
                    <span className="absolute top-3 right-3 bg-rk-navy text-rk-gold text-[9px] font-bold px-2.5 py-1 uppercase tracking-[0.18em] border border-rk-gold/40 z-10">
                        {brand.discount_percentage}% OFF
                    </span>
                )}
                {brand.is_trending && (
                    <span className="absolute top-3 left-3 rk-gradient-gold text-rk-navy text-[9px] font-bold px-2.5 py-1 uppercase tracking-[0.18em] z-10">
                        Trending
                    </span>
                )}
            </div>

            {/* Line divider + bottom row: logo (left) + text (right) */}
            <div className="border-t border-rk-border/80 bg-white px-4 py-4 flex gap-3 items-center">
                <div className="w-14 h-14 shrink-0 rk-logo-box flex items-center justify-center bg-white border border-rk-border rounded-lg overflow-hidden">
                    <BrandLogo brand={brand} size="md" />
                </div>
                <div className="flex-1 min-w-0 text-right">
                    <div className="text-[9px] uppercase tracking-[0.26em] text-rk-gold-deep mb-1 truncate">
                        {brand.category}
                    </div>
                    <h3 className="font-serif text-base text-rk-navy line-clamp-1 leading-tight group-hover:text-rk-navy-2 transition-colors">
                        {brand.brand_name}
                    </h3>
                    <div className="mt-1 flex items-center justify-end gap-2">
                        <span className="text-[10px] uppercase tracking-[0.22em] text-rk-muted">From</span>
                        <span className="font-serif text-sm font-semibold text-rk-navy">
                            {formatINR(brand.min_denomination)}
                        </span>
                        <span className="inline-flex items-center gap-1 text-xs text-rk-muted ml-1">
                            <Star className="w-3 h-3 fill-rk-gold text-rk-gold" />
                            <span className="font-semibold text-rk-navy">{brand.rating?.toFixed(1)}</span>
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
}
